import webNotification from 'simple-web-notification';

window.webNotification = webNotification;
